<div class="my-container">
  <div class="my-breadcrumbs">
    <nz-breadcrumb>
      @for (breadcrumb of breadcrumbs; track breadcrumb) {
      <nz-breadcrumb-item>{{ breadcrumb.label }}</nz-breadcrumb-item>
      }
    </nz-breadcrumb>
  </div>
  <div class="my-title">{{ title }}</div>
  <div class="my-body">
    <div class="my-form">
      <nz-spin [nzSpinning]="loading">
        @if (isError) {
        <nz-alert
          nzType="error"
          [nzMessage]="'No pudimos obtener la información del formulario de ' + title"
          [nzDescription]="errorMessage || 'Pruebe a actualizar la página e inténtelo de nuevo. Si el problema persiste no dude en contactar con nosotros'"
        >
        </nz-alert>
        } @if (!isError) {
        <div>
          <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
        </div>
        }
      </nz-spin>
    </div>
    <nz-divider class="tw-m-0"></nz-divider>
    <div class="my-footer">
      <div>
        <ng-container *ngTemplateOutlet="footerLeft"></ng-container>
      </div>
      <div>
        @if (isError && showReloadOnError) {
        <button type="button" class="tw-mr-4" nz-button nzType="default" nzSize="large" (click)="onReload()">Recargar</button>
        }
        <button type="button" class="tw-mr-4" nz-button nzType="default" nzSize="large" (click)="onCancel()">{{ 'Cancelar' | translate }}</button>
        @if (!saving && !isError) {
        <button type="button" [disabled]="loading || disableSave" nz-button nzType="primary" nzSize="large" (click)="onSave()">
          {{ 'Guardar' | translate }}
        </button>
        } @if (saving) {
        <button type="button" nz-button nzLoading nzType="primary" nzSize="large">{{ 'Guardando...' | translate }}</button>
        }
      </div>
    </div>
  </div>
</div>
